/** Decode HTML entities and strip tags from conference CSV/HTML scrapes. */
export function cleanConferenceText(raw: string | null | undefined): string {
  if (raw == null) return '';
  let text = String(raw);
  if (!text) return '';

  // Common numeric / named entities seen in WCLC/ASCO scrapes.
  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/gi, "'")
    .replace(/&#(\d+);/g, (_, n) => {
      const code = Number(n);
      return Number.isFinite(code) ? String.fromCodePoint(code) : _;
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, h) => {
      const code = parseInt(h, 16);
      return Number.isFinite(code) ? String.fromCodePoint(code) : _;
    });

  text = text.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n\n');
  text = text.replace(/<[^>]+>/g, '');
  return text.replace(/\u00a0/g, ' ').replace(/[ \t]+\n/g, '\n').trim();
}
